import { ExternalLink } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import aiRunnerImage from '../assets/discoverairunner.png';

export function AIRunner() {
  const { language } = useLanguage();

  const content = language === 'en' ? {
    title: 'Discover AI Runner',
    description: 'Experience the next generation of AI-powered tools and automation. AI Runner brings cutting-edge artificial intelligence capabilities to streamline your workflow and accelerate innovation.',
    cta: 'Explore AI Runner',
  } : {
    title: 'Odkrijte AI Runner',
    description: 'Doživite naslednjo generacijo orodij na osnovi UI in avtomatizacije. AI Runner prinaša najsodobnejše sposobnosti umetne inteligence za poenostavljenje vašega dela in pospešitev inovacij.',
    cta: 'Raziščite AI Runner',
  };

  return (
    <section id="ai-runner" className="pt-24 pb-32 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative bg-gray-900 rounded-2xl shadow-2xl overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-500 to-teal-500 opacity-10"></div>

          <div className="relative z-10 p-12 md:p-16 flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                {content.title}
              </h2>

              <p className="text-lg text-gray-300 leading-relaxed mb-8">
                {content.description}
              </p>

              <a
                href="https://airunner2033.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-violet-600 to-blue-600 text-white font-semibold rounded-lg hover:from-violet-700 hover:to-blue-700 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl"
              >
                {content.cta}
                <ExternalLink className="ml-2 w-5 h-5" />
              </a>
            </div>

            <div className="flex-1 hidden md:flex items-center justify-center">
              <div className="relative w-64 h-64 bg-gray-700 shadow-lg overflow-hidden rounded-2xl">
                <img 
                  src={aiRunnerImage}
                  alt="AI Runner" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
